import React from 'react';
function Icon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path d="M74.618-140.001L480-839.997l405.382 699.996H74.618zM178-200h604L480-720 178-200zm302-47.693q13.731 0 23.019-9.288 9.288-9.288 9.288-23.019 0-13.731-9.288-23.019-9.288-9.288-23.019-9.288-13.731 0-23.019 9.288-9.288 9.288-9.288 23.019 0 13.731 9.288 23.019 9.288 9.288 23.019 9.288zm-29.999-104.614h59.998v-200h-59.998v200zM480-460z"></path>
    </svg>;
}
export default Icon;